import React, { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, openAuth } = useAuth();

  useEffect(() => {
    if (user === false) openAuth("login");
  }, [user, openAuth]);

  if (user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 size={28} className="animate-spin text-slate-400" />
      </div>
    );
  }
  if (user === false) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
        <p className="text-lg font-semibold text-slate-900">Please log in to continue</p>
        <button
          onClick={() => openAuth("login")}
          className="rounded-lg bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white"
        >
          Log In
        </button>
      </div>
    );
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-center">
        <p className="text-lg font-semibold text-slate-900">You do not have access to this page.</p>
      </div>
    );
  }
  return children;
}
